// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".attachs .upload-cover {\n  margin-top: -5px !important;\n  height: auto !important;\n}\n.attachs .upload-cover .custom-upload, .attachs .upload-cover .uploaded-file-list {\n  min-height: 150px !important;\n  max-height: 150px !important;\n}\n.attachs .upload-cover .custom-upload .fileuploadItem, .attachs .upload-cover .uploaded-file-list .fileuploadItem {\n  height: auto !important;\n}", ""]);
// Exports
module.exports = exports;
